import useGetEntries from '../useGetEntries';

export const useGetPrivacyPolicy = () => {
  const { state, data } = useGetEntries(null, {
    include: 4,
    'sys.id': 'PRIVACY_POLICY',
  });
  const entry = data?.items?.[0]?.fields;
  const title = entry?.title;
  const sections = entry?.sections;

  return {
    sections,
    state,
    title,
  };
};
